import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

export interface GenexRuntimeConfig {
  wsUrl?: string;
}

@Injectable({ providedIn: 'root' })
export class RuntimeConfigService {
  private config: GenexRuntimeConfig = {};

  async load(): Promise<void> {
    try {
      const baseEl = document.querySelector('base');
      const baseHref = baseEl?.getAttribute('href') || '/';
      const configUrl = new URL('assets/genex-config.json', `${window.location.origin}${baseHref}`).href;
      const response = await fetch(configUrl);
      if (response.ok) {
        this.config = await response.json();
      }
    } catch {
      // 使用 environment 默认值
    }
  }

  getWsUrl(): string | undefined {
    const url = environment.wsUrl;
    return url || undefined;
  }
}
